<template>
    <div class="admin-admin mt-page">

        <crud-table :title="$i18n.gt('LABEL_MANAGE_ADMINS')"
                    item-table="super-admin"
                    item-name="Admin"
                    :new-item="newItem"
                    :filters="filters"
                    :display-fields="displayFields">
        </crud-table>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import * as _ from 'lodash'

/**
 * Page to manage super admins
 */
export default Vue.extend({
    name: 'AdminAdmin',
    data() {
        return {
            newItem: null, // can't add new items (would need to figure out how to edit userEmail)
            displayFields: [
                {key: 'userEmail', sortable: true},
            ],
        }
    },
    computed: {
        filters() {
            return {
                userEmail: {
                    field: 'userEmail',
                    type: 'string',
                    value: null,
                    label: 'User Email'
                },
            }
        },
    },
})

</script>
